import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import useInboxStateContext from "../../../../contexts/useInboxStateContext";
import { messagesSelector } from "../../../../store/state/messages/selectors";
import NoEmailsComponent from "../noEmails/NoEmailsComponent";
import MessageGrid from "./MessageGrid";

const MessagesListComponent = () => {
  const messages = useSelector(messagesSelector);
  const { ui, setMessageId, selection, setSelection } = useInboxStateContext();

  if (messages.length === 0 && !ui.messagesLoading) {
    return <NoEmailsComponent />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", flex: 1 }}>
      <Box sx={{ flex: 1 }}>
        <MessageGrid selection={selection} setSelection={setSelection} navigateToMessage={setMessageId} />
      </Box>
      <Box
        sx={(theme) => ({
          bgcolor: theme.palette.background.grey,
          height: "2rem",
          borderTop: 1,
          borderColor: theme.palette.divider,
        })}
      />
    </Box>
  );
};

export default MessagesListComponent;
